import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

const initState = {
  editForm: null,
  isUpdateRatingsLoading: false,
  formInfo: null,
};

function validate(attr, value) {
  let error = '';

  if (attr === 'client_rating') {
    if (isEmpty(value)) {
      error = 'Please select unit rating!';
    }
  }

  if (attr === 'talent_rating') {
    if (isEmpty(value)) {
      error = 'Please select talent rating!';
    }
  }

  return error;
}

function onLoad(state) {
  return {
    ...state,
    isUpdateRatingsLoading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { scores, shiftToEdit } = payload;

  return {
    ...state,
    loading: false,
    isUpdateRatingsLoading: false,
    formInfo: scores,
    editForm: shiftToEdit,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
});
